module.exports = __webpack_public_path__ + "img/40.eefdad15.jpg";